// extracted by mini-css-extract-plugin
export default {"wrapper":"T7nMD","text":"tZCSl","icon":"jRmot"};